/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMutation } from '@tanstack/react-query';
import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { FoodicsOtpVerificationAPI, FoodicsSignInAPI } from '../../../api/foodics.api';
import './index.scss';
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CFooter,
  CFormCheck,
  CFormInput,
  CImage,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import appStore from '../../../assets/stores/app-store.svg';
import googlePlay from '../../../assets/stores/google-play.svg';
import headerLogo from './daifLogo.svg';
import blogo from './Container.png';
import tv from './tv.png';
import foodicsLogo from './foodics.png';
import { cilPhone, cilLockLocked } from '@coreui/icons';
import { useFormik } from 'formik';
import { CardHeader, Toast } from 'react-bootstrap';
import env from '../../../env';
import SignInFormCheck from './formCheck';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import UseToast from '../../../hooks/useToast';
import OtpScreen from './OTP';
import { setFoodicsPriceWithVatSession } from './storage';
const FoodicsLogin = () => {
  const [otp, setOTP] = useState<string[]>(['', '', '', '']);
  const [code, setCode] = useState<string>('');
  const [country_code, setcountry_code] = useState('+966');
  const [requestState, setRequestState] = useState({
    redirect_uri: '',
    client_id: '',
    response_type: '',
    state: '',
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [iconShow, setIconShow] = useState<boolean>(false);
  const [showOTP, setShowOTP] = useState<boolean>(false);
  const [selectedPriceWithVat, setSelectedPriceWithVat] = useState<boolean | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('code')) {
      const query = searchParams.toString();
      const code = searchParams.get('code') || '';
      setCode(code);
      // const redirectUrl = `/foodics-integration/callback${query ? `?${query}` : ''}`;
      // window.location.replace(redirectUrl);
    }
  }, []);

  const packageName = 'com.beautybook.customer';
  const appleId = '6450213994';

  const appStoreLink = `itms-apps://itunes.apple.com/app/id${appleId}`;
  const playStoreLink = `market://details?id=${packageName}`;

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = _.get(e, 'target.value');
    const id = _.get(e, 'target.id');

    if (value !== ' ') {
      if (
        (id === 'contactNumber' && value.length === 10) ??
        (id === 'password' && value.length === 17)
      ) {
        return null;
      } else {
        setFieldValue(id, value);
      }
    }
  };

  const { mutate: sendOtp, isLoading: sendOtpLoading } = useMutation(FoodicsOtpVerificationAPI, {
    onSuccess(data, variables, context) {
      const SuccessMsg = data?.data?.message;
      const redirectURL = data?.data?.redirectURL;
      UseToast(SuccessMsg, 'success');

      if (selectedPriceWithVat === null) {
        UseToast('Please select how prices should be imported | اختر طريقة استيراد الأسعار', 'error');
        return;
      }

      if (redirectURL) {
        setFoodicsPriceWithVatSession(selectedPriceWithVat);
        window.location.href = redirectURL;
      }

      //todo
    },
    onError: (data: any) => {
      const ErrMsg = data?.data?.message;
      setOTP(['', '', '', '']);
      inputRef.current?.focus();
      console.log(ErrMsg, 'error');
    },
  });

  const { mutate, isLoading } = useMutation(FoodicsSignInAPI, {
    onSuccess: (data) => {
      setShowOTP(true);
      UseToast('Verification code has been sent - تم إرسال رمز التحقق', 'success');
    },
    onError: (data: any) => {
      const ErrMsg = data?.data?.message;
      console.log(ErrMsg, 'ErrMsgErrMsg');
    },
  });

  const { handleSubmit, values, handleBlur, errors, touched, setFieldValue } = useFormik({
    validationSchema: SignInFormCheck,
    initialValues: {
      email: '',
      password: '',
      countryPrefix: country_code,
      contactNumber: '',
      priceWithVat: null as boolean | null,
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      // eslint-disable-next-line no-restricted-globals
      event?.preventDefault();
      const { priceWithVat, ...signInPayload } = values;
      mutate({
        ...signInPayload,
      });
    },
  });

  return (
    <div
      style={{
        backgroundImage: `url(${tv})`,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'space-between',
      }}
    >
      <title>Daif - Sign In</title>
      <CCard style={{ backgroundImage: `url(${tv})` }}>
        <CardHeader className="booking-header">
          <div className="booking-logo">
            <CImage
              width={'100px'}
              height={'50px'}
              align="start"
              alt="logo"
              src={headerLogo}
              className="profile-picture"
            />
            <span style={{ marginLeft: '20px', marginRight: '20px' }}>|</span>
            <CImage
              width={'120px'}
              height={'50px'}
              align="start"
              alt="logo"
              src={foodicsLogo}
              className="profile-picture"
            />
          </div>
        </CardHeader>
        <CCardBody
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flexGrow: 1,
          }}
        >
          {showOTP ? (
            <OtpScreen
              contactNumber={values.contactNumber}
              countryPrefix={values.countryPrefix}
              password={values.password}
              isLoading={sendOtpLoading}
              sendOtp={sendOtp}
              otp={otp}
              code={code}
              setOTP={setOTP}
              ref={inputRef}
            />
          ) : (
            <div>
              <CRow className="justify-content-center mb-4">
                <CCol xs="12" lg="8">
                  <CImage
                    width={'50%'}
                    style={{ minHeight: '120px', minWidth: '220px' }}
                    align="center"
                    alt="logo"
                    src={blogo}
                  />
                </CCol>
              </CRow>
              <CRow className="justify-content-center mb-4">
                <CCol xs="12" lg="3">
                  <h6 className="mb-4" style={{ color: '#fff' }}>
                    Already using Foodics? Seamlessly migrate your data to Daif.
                    <br />
                    Foodics is a powerful integrated point-of-sale system trusted by many
                    businesses.
                    <br />
                    If you are currently using Foodics, you can easily transfer your data to Daif
                    without losing a step.
                  </h6>
                  <h6 className="mb-4 text-right" style={{ color: '#fff' }}>
                    هل تستخدم نظام فودكس ؟ يمكنك نقل بياناتك بسهولة إلى ضيف
                    <br />
                    يُعد نظام فودكس من أفضل أنظمة نقاط البيع المتكاملة، ويعتمد عليه العديد من أصحاب
                    الأعمال
                    <br />
                    إذا كنت تستخدم فودكس حاليًا، يمكنك نقل بياناتك بسهولة إلى ضيف دون أي تعقيدات
                  </h6>
                </CCol>
              </CRow>

              <CRow className="justify-content-center">
                <CCol
                  xs="12"
                  lg="3"
                  className="text-end d-none d-lg-block"
                  style={{ color: '#F7C72E' }}
                >
                  Contact Number
                </CCol>

                <CCol xs="6" lg="3" className="d-lg-none" style={{ color: '#F7C72E' }}>
                  Contact Number
                </CCol>

                <CCol xs="6" lg="3" className="text-end d-lg-none" style={{ color: '#F7C72E' }}>
                  رقم الجوال
                </CCol>

                <CCol xs="12" md="12" sm="12" lg="6">
                  <CInputGroup className="mb-3 contact-div">
                    <CInputGroupText className="iconSize">
                      <CIcon icon={cilPhone} />
                    </CInputGroupText>
                    <CInputGroupText className="iconSize">{country_code}</CInputGroupText>

                    <CFormInput
                      type="number"
                      min={0}
                      placeholder="5555555555"
                      autoComplete="contactNumber"
                      id="contactNumber"
                      value={values.contactNumber}
                      onChange={handleOnChange}
                      onBlur={handleBlur}
                      invalid={touched.contactNumber && Boolean(errors.contactNumber)}
                      feedback={
                        touched.contactNumber &&
                        Boolean(errors.contactNumber) &&
                        errors.contactNumber
                      }
                      onWheel={(e) => e.currentTarget.blur()}
                      onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                    />
                  </CInputGroup>
                </CCol>

                <CCol xs="12" lg="3" className="d-none d-lg-block" style={{ color: '#F7C72E' }}>
                  رقم الجوال
                </CCol>
              </CRow>
              <CRow className="justify-content-center">
                <CCol
                  xs="12"
                  lg="3"
                  className="text-end d-none d-lg-block"
                  style={{ color: '#F7C72E' }}
                >
                  Password
                </CCol>

                <CCol xs="6" lg="3" className="d-lg-none" style={{ color: '#F7C72E' }}>
                  Password
                </CCol>

                <CCol xs="6" lg="3" className="text-end d-lg-none" style={{ color: '#F7C72E' }}>
                  كلمة المرور
                </CCol>
                <CCol xs="12" md="12" sm="12" lg="6">
                  <CInputGroup className="wid-75" style={{ userSelect: 'none' }}>
                    <CInputGroupText>
                      <CIcon icon={cilLockLocked} />
                    </CInputGroupText>

                    <CFormInput
                      onPaste={(e: any) => {
                        if (env.env != 'local') {
                          e.preventDefault();
                          return false;
                        }
                      }}
                      type={iconShow ? 'text' : 'password'}
                      maxLength={16}
                      placeholder="**************"
                      autoComplete="password"
                      id="password"
                      onBlur={handleBlur}
                      value={values.password}
                      invalid={touched.password && Boolean(errors.password)}
                      onChange={(e) => handleOnChange(e)}
                      disabled={isLoading}
                      autoFocus={false}
                      capture={false}
                    />
                    <CInputGroupText
                      onClick={() =>
                        setIconShow((prevState) => {
                          return !prevState;
                        })
                      }
                    >
                      {iconShow ? <AiFillEye /> : <AiFillEyeInvisible />}
                    </CInputGroupText>
                  </CInputGroup>
                  <p className="text-danger f-25">
                    {touched.password && Boolean(errors.password) && errors.password}
                  </p>
                </CCol>
                <CCol xs="12" lg="3" className="d-none d-lg-block" style={{ color: '#F7C72E' }}>
                  كلمة المرور
                </CCol>
              </CRow>

              <CRow className="justify-content-center">
                <CCol
                  xs="12"
                  lg="3"
                  className="text-end d-none d-lg-block"
                  style={{ color: '#F7C72E' }}
                >
                  Foodics Price Mode
                </CCol>
                <CCol xs="12" md="12" sm="12" lg="6">
                  <div
                    style={{
                      border: '1px solid #ffffff33',
                      borderRadius: 8,
                      padding: 12,
                      background: '#00000022',
                    }}
                  >
                    <p style={{ color: '#fff', marginBottom: 8 }}>
                      Select how prices should be imported | اختر طريقة استيراد الأسعار:
                    </p>
                    <CFormCheck
                      className="mb-2"
                      type="radio"
                      id="priceWithVatTrue"
                      name="priceWithVat"
                      checked={values.priceWithVat === true}
                      onChange={() => {
                        setFieldValue('priceWithVat', true);
                        setSelectedPriceWithVat(true);
                      }}
                      onBlur={handleBlur}
                      label={
                        <span style={{ color: '#fff' }}>
                          Prices include VAT | الأسعار تشمل ضريبة القيمة المضافة
                        </span>
                      }
                    />
                    <CFormCheck
                      type="radio"
                      id="priceWithVatFalse"
                      name="priceWithVat"
                      checked={values.priceWithVat === false}
                      onChange={() => {
                        setFieldValue('priceWithVat', false);
                        setSelectedPriceWithVat(false);
                      }}
                      onBlur={handleBlur}
                      label={
                        <span style={{ color: '#fff' }}>
                          Prices without VAT | الأسعار بدون ضريبة القيمة المضافة
                        </span>
                      }
                    />
                  </div>
                  <p className="text-danger f-25 mt-1">
                    {touched.priceWithVat && Boolean(errors.priceWithVat) && errors.priceWithVat}
                  </p>
                </CCol>
                <CCol xs="12" lg="3" className="d-none d-lg-block" style={{ color: '#F7C72E' }}>
                  طريقة استيراد الأسعار
                </CCol>
              </CRow>

              <CRow className="justify-content-center">
                <CCol xs="12" lg="12" className="text-center mt-4">
                  <button
                    className="px-4 sbtn"
                    onClick={() => handleSubmit()}
                    disabled={isLoading || values.priceWithVat === null}
                  >
                    Sign In | تسجيل الدخول
                  </button>
                </CCol>
              </CRow>
            </div>
          )}
        </CCardBody>
      </CCard>

      <CFooter className="booking-footer">
        <div style={{ width: '100%' }}>
          <CRow className="justify-content-center align-items-center pb-5 mt-3">
            <CCol xs="auto">
              <a href={appStoreLink} className="text-white mr-4">
                <img
                  src={appStore}
                  alt="appStore"
                  style={{ maxWidth: '150px', maxHeight: '50px' }}
                />
              </a>
            </CCol>
            <CCol xs="auto">
              <a href={playStoreLink} className="text-white">
                <img
                  src={googlePlay}
                  alt="googlePlay"
                  style={{ maxWidth: '150px', maxHeight: '50px' }}
                />
              </a>
            </CCol>
          </CRow>
        </div>
      </CFooter>
    </div>
  );
};

export default FoodicsLogin;
